import "./styles.scss";
import "CompLib/basics/image-resp";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

import "./styles.scss";

class BeforeAfterImageScrollSlide {
  constructor(domElem = document.querySelector(".before-after-image-scroll-slide")) {
    this.DOM = { slidesWrapper: domElem };
    if (!this.DOM.slidesWrapper) return;
    this.DOM.beforeWrapper = this.DOM.slidesWrapper.querySelector(`.before-wrp`);
    this.DOM.beforeImage = this.DOM.beforeWrapper.querySelector(`img`);
    this.timeline = undefined;
    this.addTimelineScrollAnimation();
    // this.refreshOnLazy();
    window.st_refresh = ScrollTrigger.refresh();
    ScrollTrigger.normalizeScroll(true);
  }

  addTimelineScrollAnimation = () => {
    console.log(this.DOM.slidesWrapper.offsetWidth);
    this.timeline = gsap
      .timeline({
        defaults: { ease: "none" },
        scrollTrigger: {
          trigger: this.DOM.slidesWrapper,
          start: "center center",
          end: () => "+=" + this.DOM.slidesWrapper.offsetWidth,
          scrub: true,
          invalidateOnRefresh: true,
          pin: "#super-slider",
          markers: false,
        },
      })
      .to(this.DOM.beforeImage, {
        xPercent: -100,
      })
      .to(
        this.DOM.beforeWrapper,
        {
          xPercent: 100,
        },
        0,
      );
  };
}

export { BeforeAfterImageScrollSlide };
